import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

@Component({
  selector: 'tellent-assistant-reasoning-part',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <details [open]="open()" (toggle)="onToggle($event)">
      <summary>{{ done() ? label() : 'Thinking…' }}</summary>
      <pre class="content">{{ content() }}</pre>
    </details>
  `,
  styleUrls: ['./reasoning-part.component.less'],
})
export class TellentAssistantReasoningPartComponent {
  public readonly content = input.required<string>();
  public readonly done = input.required<boolean>();
  public readonly durationMs = input<number | null>(null);
  public readonly open = signal<boolean>(false);

  protected label(): string {
    const ms = this.durationMs();
    if (ms == null) return 'Worked';
    const s = Math.max(1, Math.round(ms / 1000));
    return `Worked for ${s}s`;
  }

  protected onToggle(event: Event): void {
    const el = event.target as HTMLDetailsElement;
    this.open.set(el.open);
  }
}
